export type ClassType = 'Warrior' | 'Ranger' | 'Huntress' | 'Witch' | 'Sorceress' | 'Mercenary' | 'Monk' | 'Druid';

export const classPresetTexts: { [preset in ClassType]: string } = {
  'Warrior': "Uses One-or Two-Handed Maces. Wears Heavy Armour and a shield.",
  'Ranger': "Uses Bows. Wears primarily Evasion armour.",
  'Huntress': "Uses Spears and Bucklers. Wears primarily Evasion armour.",
  'Witch': "Uses Wands and Sceptres. Wears Energy Shield armour.",
  'Sorceress': "Uses Staves. Wear Energy Shield armour.",
  'Mercenary': "Uses Crossbows. Wears Evasion and Heavy Armour.",
  'Monk': "Uses Quarterstaves. Wears Evasion and Energy Shield armour.",
  'Druid': "Uses Talismans. Wears Armour and Energy Shield armour.",
}

export const classes: { name: ClassType, image: string }[] = [
  { name: 'Warrior', image: '/img/presets/warrior.webp' },
  { name: 'Ranger', image: '/img/presets/ranger.webp' },
  { name: 'Huntress', image: '/img/presets/huntress.webp' },
  { name: 'Witch', image: '/img/presets/witch.webp' },
  { name: 'Sorceress', image: '/img/presets/sorceress.webp' },
  { name: 'Mercenary', image: '/img/presets/mercenary.webp' },
  { name: 'Monk', image: '/img/presets/monk.webp' },
  { name: 'Druid', image: '/img/presets/druid.webp' },
  // Heads up, when adding a new class, also update the starter weapons list in leveling-gear-generator.service.ts
];
